import { callOrganizationServiceApi } from '../../../apis/organizationService';

/**
 * One page of the locations an identity can access, from organization-service:
 * its direct location grants plus every location inherited through a group or
 * organization grant, ordered by name.
 *
 * `q` is a case-insensitive substring of the location name, and organization-
 * service answers 422 `invalid_query` past 255 characters. It is omitted when
 * empty, so no search and an empty one are the same request.
 *
 * @param {Object} params
 * @param {string} params.identityId - The auth-service user id
 * @param {string} [params.q] - Part of a location name
 * @param {number} params.page - 1-based page
 * @param {number} params.limit - Page size, 1-200
 * @returns {Promise<import('../types/User.api').IGetIdentityLocationsApiResponse>}
 */
export const getIdentityLocations = ({
  identityId, q, page, limit,
}) =>
  callOrganizationServiceApi('get', `admin/identities/${identityId}/locations`, {
    params: { q: q || undefined, page, limit },
  });
